<template>
  <div class="map-button">
    <a class="cx-link" target="_blank"
      :href="mapURL"><span v-if="!hideIcon" class="cx-link__icon">
        <i class="fal fa-map"></i>
      </span><span>{{ text || $t(`media.${ mapToUse }`) }}</span>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import coordtransform from 'coordtransform';

export default {
  name: 'map-button',
  props: {
    text: { type: String, default: '' },
    coord: { type: Object, default: {} },
    hideIcon: { type: Boolean, default: false },
  },
  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile,
      isGeolocationOn: state => state.geolocation.isGeolocationOn,
      mapBoxGeolocationOn: state => state.geolocation.mapBoxGeolocationOn,
      userLocation: state => state.geolocation.userLocation
    }),
    isZhHans() {
      return this.$i18n.locale.toLowerCase() == 'zh-hans';
    },
    mapURL() {
      return this.getMapURL();
    },
    lat() {
      return this.coord.lat;
    },
    lon() {
      return this.coord.lon;
    },
    mapToUse() {
      return this.isZhHans ? 'aMap' : 'googleMap'
    },
  },
  methods: {
    getMapURL(info) {
      return this[this.mapToUse + 'URL']
        ? this[this.mapToUse + 'URL']()
        : '';
    },
    googleMapURL() {
      return `https://maps.google.com/maps/dir/?api=1&destination=${this.lon},${this.lat}&travelmode=transit`
    },
    aMapURL() {
      let protocol = 'https';
      let gcj = coordtransform.wgs84togcj02(this.lat, this.lon);

      if (this.isMobile) {
        // need to transform the wgs to gcj
        // Since m.amap.com can't feed coordinate
        return `${protocol}://uri.amap.com/navigation?to=${gcj[0]},${gcj[1]},${name}&mode=bus&coordinate=wgs84&callnative=1`
      } else {
        return (this.mapBoxGeolocationOn
            // need to transform the wgs to gcj
            // Since m.amap.com can't feed coordinate
            ? `${protocol}://uri.amap.com/navigation?from=${this.userLocation[0]},${this.userLocation[1]},我的位置&to=${gcj[0]},${gcj[1]},${name}&mode=bus&coordinate=wgs84&callnative=1`
            : `${protocol}://uri.amap.com/marker?position=${this.lat},${this.lon}&name=${name}&coordinate=wgs84&callnative=1`)
      }
    }
  },
};
</script>
